import React from 'react';
import { Box, Chip, Stack, Divider, Button } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const historyTyp = [
  { id: 1, value: 'M', label: 'MY  결재', color: 'warning' },
  { id: 2, value: 'D', label: 'ALL 결재', color: 'success' },
  { id: 3, value: 'N', label: '상신', color: 'info' },
];

const docTyp = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: '수주', label: '수주', color: 'success' },
  { id: 2, value: '기술', label: '기술', color: 'info' },
  { id: 3, value: '세금', label: '세금', color: 'secondary' },
];

const appStatus = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: 'Y', label: '결재완료', color: 'success' },
  { id: 2, value: 'S', label: '결재중', color: 'info' },
  { id: 3, value: 'N', label: '결재반려', color: 'default' },
];

const ApprovalStatusList = ({
  searchStatus,
  onChangeStatus,
  searchDocTyp,
  onChangeDocTyp,
  searchType,
  onChangeTyp,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItem: 'center',
        m: 1,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        <Box>
          {historyTyp &&
            historyTyp.map((st, index) => (
              <Button
                key={index}
                sx={{ mr: 2 }}
                variant={st.value === searchType ? 'contained' : 'outlined'}
                color={st.color}
                onClick={() => onChangeTyp(st.value)}
              >
                {st.label}
              </Button>
            ))}
        </Box>
        <Box>
          {docTyp &&
            docTyp.map((st, index) => (
              <Chip
                sx={{ mr: 2 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={st.value === searchDocTyp ? 'contained' : 'outlined'}
                color={st.color}
                onClick={() => onChangeDocTyp(st.value)}
              />
            ))}
        </Box>
        <Box>
          {appStatus &&
            appStatus.map((st, index) => (
              <Chip
                sx={{ mr: 2 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={st.value === searchStatus ? 'contained' : 'outlined'}
                color={st.color}
                onClick={() => onChangeStatus(st.value)}
              />
            ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default ApprovalStatusList;
